import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import InputAdornment from '@mui/material/InputAdornment'
import { OutlinedInputProps } from '@mui/material/OutlinedInput'
import TextField from '@mui/material/TextField'
import React from 'react'

interface QuickSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  placeholder?: string;
  autoFocus?: boolean;
  InputProps?: Partial<OutlinedInputProps>;
}

export default function QuickSearchInput(props: QuickSearchInputProps): React.ReactElement {
  const {
    value,
    onChange,
    onKeyDown,
    placeholder,
    autoFocus,
    InputProps,
  } = props

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.value)
  }

  return (
    <Box sx={{ p: 2, pb: 0 }}>
      <TextField
        fullWidth
        value={value}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        variant="outlined"
        autoFocus={autoFocus}
        inputProps={{
          'aria-label': 'Quick Search Input',
        }}
        InputProps={{
          ...InputProps,
          startAdornment: (
            <InputAdornment position="start" sx={{ gap: 1 }}>
              <Divider orientation="vertical" flexItem sx={{ mx: 0.5, my: 1 }} />
              {InputProps?.startAdornment}
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {InputProps?.endAdornment}
              <Chip label="esc" size="small" sx={{ height: 24 }} />
            </InputAdornment>
          ),
          sx: {
            fontSize: '1.125rem',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              borderBottom: 1,
              borderColor: 'divider',
              borderRadius: 0,
            },
            ...InputProps?.sx,
          },
        }}
      />
    </Box>
  )
}
